const ONE_HOUR_MILLIS_SEC = 60 * 60 * 1000;
const GMT_0800_OFFSET = ONE_HOUR_MILLIS_SEC * 8;
const ONE_DAY_MILLIS_SEC = 24 * ONE_HOUR_MILLIS_SEC;
const ONE_MILLIS_SEC_BEFORE_NEXT_DAY = ONE_DAY_MILLIS_SEC - 1;

export default class TimeUtils {
  static ONE_DAY_MILLIS_SEC = ONE_DAY_MILLIS_SEC;

  /**
   * To remove the time part from the date
   * e.g. 2021-07-01 00:00:00.000
   * @param {*} time
   * @returns
   */
  static removeTimePart(time) {
    time = this.timezoneToGMTZ(time);
    time = time - (time % ONE_DAY_MILLIS_SEC);
    return this.timezoneOffset(time);
  }

  /**
   * To get a time that is 1 millis second before the next day
   * e.g. 2021-07-01 23:59:59.999
   * @param {*} time
   * @returns
   */
  static getTimeBeforeNextDay(time) {
    return TimeUtils.removeTimePart(time) + ONE_MILLIS_SEC_BEFORE_NEXT_DAY;
  }

  // These functions are for date calculation, e.g. Remove time part from date-time.
  static timezoneOffset(time) {
    return time - GMT_0800_OFFSET;
  }

  static timezoneToGMTZ(time) {
    return time + GMT_0800_OFFSET;
  }

  static isValidDateRange(from, to, allowAfterToday = false) {
    var now = Date.now();
    now = TimeUtils.getTimeBeforeNextDay(now);
    if (!allowAfterToday) {
      if ((from && from > now) || (to && to > now)) return false;
    }
    return (!from && !to) || !!(from && to && from <= to);
  }
}
